import React from "react";
import "./style.scss";
import discordIcon from "../../../assets/icons/discord_logo_blue.svg";
const DiscordConnection = () => {
  return (
    <div className="discord_conn_container">
      <div className="discord_conn_wrapper">
          <img src={discordIcon} alt="" />
        <div className="discord_desc">
          <h2>Connect Your Discord</h2>
          <p>
            Gain recognition in our community by connecting your Discord account
            to your ACG Futures account. When you attain funded status, you will
            be given a special role in our Discord server. This role will give
            you access to our funded traders chat room, where you can discuss
            trading ideas and strategies with other funded traders.
          </p>
        </div>
        <div className="connect_button">
          <button>Connect Discord</button>
        </div>
      </div>
    </div>
  );
};

export default DiscordConnection;
